module.exports = __webpack_public_path__ + "static/media/transport.65643b05.jpg";